import { render, staticRenderFns } from "./_rbData.vue?vue&type=template&id=383ce38e&scoped=true&lang=pug&"
import script from "./_rbData.vue?vue&type=script&lang=js&"
export * from "./_rbData.vue?vue&type=script&lang=js&"
import style0 from "./_rbData.vue?vue&type=style&index=0&id=383ce38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ce38e",
  null
  
)

export default component.exports